import { RefObject, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../redux/hooks";

// Generic type for the fetch action that accepts a URL
type FetchActionCreator = (url: string) => any;

export const useScrollablePagination = (
  ref: RefObject<HTMLDivElement | null>,
  fetchAction: FetchActionCreator,
) => {
  const dispatch = useAppDispatch();
  const { loading, next } = useAppSelector((state) => state.folder);

  useEffect(() => {
    if (!next) return;

    const observer = new IntersectionObserver((entries) => {
      const lastEntry = entries[0];
      if (lastEntry.isIntersecting && !loading && next) {
        dispatch(fetchAction(next));
      }
    });

    const currentRef = ref.current;
    let lastItem: Element | null = null;
    if (currentRef) {
      lastItem = currentRef.lastElementChild;
      if (lastItem) {
        observer.observe(lastItem);
      }
    }

    return () => {
      if (lastItem) {
        observer.unobserve(lastItem);
      }
    };
  }, [ref.current, dispatch, loading, next, fetchAction]);
};
